import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AuthHeader from './components/AuthHeader';
import Login from './components/Login';
import Register from './components/Register';
import ECMRList from './components/ECMRList';
import ImportECMR from './components/ImportECMR';
import ViewECMR from './components/ViewECMR';
import CreateECMR from './components/CreateECMR';
import EditECMR from './components/EditECMR';
import ExportECMR from './components/ExportECMR';
import OperationalEvidenceWorkflows from './components/OperationalEvidenceWorkflows';
import RetentionLegalHoldWorkflows from './components/RetentionLegalHoldWorkflows';
import AmendmentWorkflows from './components/AmendmentWorkflows';
import DocumentAuditTrail from './components/DocumentAuditTrail';
import SupplementaryDocuments from './components/SupplementaryDocuments';
import EvidenceDashboard from './components/EvidenceDashboard';
import FinalXmlArchive from './components/FinalXmlArchive';
import ValidateECMR from './components/ValidateECMR';
import SignECMR from './components/SignECMR';
import DocumentWorkflow from './components/DocumentWorkflow';
import LegalNotice from './components/LegalNotice';
import './App.css';

// Create Material-UI theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#2563eb', // blue-600
    },
    secondary: {
      main: '#dc2626', // red-600
    },
  },
});

function App() {
  const [isLegalNoticeOpen, setIsLegalNoticeOpen] = useState(false);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-gray-100">
            <AuthHeader />
            
            <main className="py-4">
              <Routes>
                {/* Public routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                
                {/* Protected document routes */}
                <Route path="/" element={<ProtectedRoute><ECMRList /></ProtectedRoute>} />
                <Route path="/import" element={<ProtectedRoute><ImportECMR /></ProtectedRoute>} />
                <Route path="/view/:id" element={<ProtectedRoute><ViewECMR /></ProtectedRoute>} />
                <Route path="/create" element={<ProtectedRoute><CreateECMR /></ProtectedRoute>} />
                <Route path="/edit/:id" element={<ProtectedRoute><EditECMR /></ProtectedRoute>} />
                <Route path="/export/:id" element={<ProtectedRoute><ExportECMR /></ProtectedRoute>} />
                <Route path="/evidence/:id" element={<ProtectedRoute><OperationalEvidenceWorkflows /></ProtectedRoute>} />
                <Route path="/retention/:id" element={<ProtectedRoute><RetentionLegalHoldWorkflows /></ProtectedRoute>} />
                <Route path="/amendments/:id" element={<ProtectedRoute><AmendmentWorkflows /></ProtectedRoute>} />
                <Route path="/audit/:id" element={<ProtectedRoute><DocumentAuditTrail /></ProtectedRoute>} />
                <Route path="/attachments/:id" element={<ProtectedRoute><SupplementaryDocuments /></ProtectedRoute>} />
                <Route path="/evidence-dashboard/:id" element={<ProtectedRoute><EvidenceDashboard /></ProtectedRoute>} />
                <Route path="/final-xml/:id" element={<ProtectedRoute><FinalXmlArchive /></ProtectedRoute>} />
                <Route path="/validate/:id" element={<ProtectedRoute><ValidateECMR /></ProtectedRoute>} />
                <Route path="/sign/:id" element={<ProtectedRoute><SignECMR /></ProtectedRoute>} />
                <Route path="/workflow/:id" element={<ProtectedRoute><DocumentWorkflow /></ProtectedRoute>} />
              </Routes>
            </main>
            
            <footer className="bg-gray-800 text-white p-4">
              <div className="container mx-auto text-center">
                <p className="mb-2">© {new Date().getFullYear()} Open e-CMR - Aplicación para la gestión de documentos e-CMR</p>
                <button
                  onClick={() => setIsLegalNoticeOpen(true)}
                  className="text-sm text-gray-400 hover:text-white underline"
                >
                  Aviso Legal
                </button>
              </div>
            </footer>

            <LegalNotice 
              isOpen={isLegalNoticeOpen}
              onClose={() => setIsLegalNoticeOpen(false)}
            />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
